var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"compare",staticStyle:{"width":"100%","height":"100%"}},[_c('l-map',{ref:"compareMap",staticStyle:{"z-index":"0","background-color":"black"},attrs:{"options":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }